import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { deleteAutoConsumption, fetchAutoConsumptions, fetchGoods, fetchRawsList, setActiveModalAction, setAutoConsumptionEdit, setAutoConsumptionsPaging, updateAutoConsumption } from "../../../action";
import { isEmpty } from "lodash";
import swal from 'sweetalert';
import ReactPaginate from "react-paginate";
import Content from "../../../components/layout/Content";
import Portlet from "../../../components/utils/Portlet";
import ErrorContainer from "../../../components/utils/ErrorContainer";
import Loader from "../../../components/utils/Loader";
import { styles } from "../../../containers/goods/styles";
import cn from 'classnames';
import { fromStore } from "../../../selectors";

export default function AutomaticConsumptionList() {
    const data = useSelector((state) => state.automaticConsumption);
    const loading = useSelector((state) => state.loaders.autoConsumptions);
    const loaderUpdate = useSelector((state) => state.loaders.editAutoConsumption);
    const goods = useSelector(state => state.good.list);
    const raws = useSelector(fromStore.rawListSelector);
    const { list, count, paging } = data;

    const [currentPage, setCurrentPage] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(list)) dispatch(fetchAutoConsumptions());
        if (isEmpty(goods)) dispatch(fetchGoods());
        if (isEmpty(raws)) dispatch(fetchRawsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDelete = (id) => {
        swal({
            title: `Удаление авторасхода`,
            text: `Вы действительно хотите удалить авторасхода #${id}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then(async (willDelete) => {
            if (willDelete) {
                const res = await dispatch(deleteAutoConsumption(id));
                if (res) onRefresh()
            }
        });
    }

    const onToogleActive = async (item) => {
        const data = { active: !item.active, };
        const res = await dispatch(updateAutoConsumption(item.id, data));
        if (res) onRefresh()
    };

    const onRefresh = () => {
        dispatch(fetchAutoConsumptions());
    }

    const openModalAdd = () => {
        dispatch(setActiveModalAction({ field: 'autoConsumption', value: 'new' }));
    }

    const openModalEdit = async (item) => {
        dispatch(setAutoConsumptionEdit(item));
        dispatch(setActiveModalAction({ field: 'autoConsumption', value: item.id }));
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Авторасход</h3>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <button onClick={openModalAdd} className="btn btn-success btn-icon-sm">
                            Добавить авторасход
                        </button>
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const getTitleProduct = (autoConsumption) => {
        if (!autoConsumption || !autoConsumption.idProduct || !autoConsumption.typeProduct) return '-';
        const { idProduct, typeProduct } = autoConsumption;
        const arr = typeProduct === 'good' ? goods : raws;
        const entity = arr.find((item) => item.id === parseInt(idProduct));
        if (entity && entity.name) return entity.name;
        return '-';
    }

    const renderTable = () => {
        if (loading) return(
            <div style={styles.tableLoading}>
                <Loader text="Загружаем данные..."/>
            </div>
        );
        
        return (
            <table className="kt-datatable__table" style={window.innerWidth > 730 ? { minHeight: '700px' } : {}}>
                <thead className="kt-datatable__head">
                    <tr className='kt-datatable__row'>
                        <th className='kt-datatable__cell good_id'><span>ID</span></th>
                        <th className='kt-datatable__cell' style={{ width: '200px' }}><span>Продукт</span></th>
                        <th className='kt-datatable__cell' style={{ width: '200px' }}><span>Кол-во продукта</span></th>
                        <th className='kt-datatable__cell' style={{ width: 'auto' }}><span>От</span></th>
                        <th style={{ textAlign: 'right' }} className='kt-datatable__cell table_action'><span>Действия</span></th>
                    </tr>
                </thead>
                <tbody className="kt-datatable__body">
                {
                    loading ? null : isEmpty(list) ? (
                            <tr>
                                <td colSpan={4}>
                                    <span className="kt-datatable--error">
                                        Авторасхода нет
                                    </span>
                                </td>
                            </tr>
                        )
                        : (
                            list.map((item) => {
                                return (
                                    <tr className="kt-datatable__row" onDoubleClick={() => openModalEdit(item)}>
                                        <th className='kt-datatable__cell good_id'><span>{item.id}</span></th>
                                        <td className="kt-datatable__cell" style={{ width: '200px' }}><span>{getTitleProduct(item)}</span></td>
                                        <td className="kt-datatable__cell" style={{ width: '200px' }}><span>{item.countProduct}</span></td>
                                        <td className="kt-datatable__cell" style={{ width: 'auto' }}><span>Приборы</span></td>
                                        <td align='right' className='kt-datatable__cell table_action'>
                                        <div style={{ width: '100%', height: '100%'}}>
                                            {loaderUpdate && <span style={{overflow: 'visible', position: 'relative', width: '80px'}}><button className='btn btn-sm btn-clean btn-icon btn-icon-md kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger'></button></span> }
                                            <button 
                                                onClick={() => onToogleActive(item)}
                                                data-tip={item.active ? 'Выключить' : 'Включить'}
                                                disabled={loaderUpdate}
                                                className={cn("btn btn-sm btn-icon btn-icon-md", {
                                                    'btn-danger': !item.active,
                                                    'btn-success': item.active,
                                                    'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                                                })}>
                                                {!loaderUpdate && <i className="la la-power-off"></i>}
                                            </button>
                                            <button 
                                                style={{ marginLeft: '5px' }}
                                                onClick={() => onDelete(item.id)}
                                                data-tip={'Удалить'}
                                                disabled={loaderUpdate}
                                                className={cn("btn btn-sm btn-icon btn-icon-md btn-danger", {
                                                    'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                                                })}>
                                                {!loaderUpdate && <i className="la la-trash"></i>}
                                            </button>
                                        </div>     
                                    </td>
                                    </tr>
                                )
                            })
                        )
                }
                </tbody>
            </table>
        );
    }

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        let nextStart =  data.selected * paging.limit;
        const updatedPaging = {...paging, start: nextStart};
        dispatch(setAutoConsumptionsPaging(updatedPaging));
        dispatch(fetchAutoConsumptions());
    };

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { start: 0, limit: e.target.value};
        setCurrentPage(0);
        dispatch(setAutoConsumptionsPaging(updatedPaging));
        dispatch(fetchAutoConsumptions());
    }

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if (userDisplayWidth < 400) return 1;
        if (userDisplayWidth < 550) return 2;
        if (userDisplayWidth < 850) return 3;
        if (userDisplayWidth < 1250) return 5;
        return 8;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 5;
    }

    const renderPagination = () => {
        const pages = Math.ceil(+count / +paging.limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />

                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={paging.limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            paging.start + paging.limit >= count ? (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+count} из {count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {paging.start + 1} - {+paging.start + +paging.limit} из {count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }
    
    return (
        <Content>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <Portlet fit={true} style={{ backgroundColor: '#00000000'}}>
                        <ErrorContainer field="autoConsumptions" style={{ margin: 15 }} hasCloseButton={true}/>
                        <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded" style={{ marginBottom: '0px'}}>
                            {renderTable()}
                            {
                                !loading && count > 0 && renderPagination()
                            }
                        </div>
                    </Portlet>
                </div>
        </Content>
    )
}